import React from 'react'

import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import { useTripCollaborators } from 'tripPlanner/hooks/api/collaborator'
import type { BasicTrip } from 'tripPlanner/types/common'

interface Props {
  trip: BasicTrip
}

export default function MyTripsTileShareContent({ trip }: Props) {
  const { data } = useTripCollaborators({
    tripId: trip.id,
  })

  const owner = data?.collaborators.find((i) => i.role === 'OWNER')

  // User hasn't shared
  if (!data?.collaborators || data.collaborators.length < 2) {
    return null
  }

  return (
    <>
      {trip.role === 'OWNER' && (
        <CaptionTextBlock
          variant="large"
          startIcon={<LineUsersAltIcon size="XS" />}
        >
          Shared by you
        </CaptionTextBlock>
      )}
      {trip.role !== 'OWNER' && owner && (
        <CaptionTextBlock
          variant="large"
          startIcon={<LineUsersAltIcon size="XS" />}
        >
          Shared by {owner?.givenName || 'user'}
        </CaptionTextBlock>
      )}
    </>
  )
}
